// import { getToApi, getToRails } from 'venuescanner-js/services/api'
import isSSR from "venuescanner-js/services/isSSR";
import Space from "./space";
import SpaceSdp from "./SpaceSdp";
// import serviceURLs from '../serviceURLs.json'
import controllers from "../controllers";
import debounce from "debounce";

/** @module
 * @name Spaces
 * @desc Service class for fetching Spaces
 */
const Spaces = {
  versions: {
    standard: {
      controller: controllers.spaceService.spaces.get,
      spaces: {},
      inflights: {},
    },
    sdp: {
      controller: controllers.spaceService.spacesSdp.post,
      spaces: {},
      inflights: {},
    },
  },
  inflights: [],
  /**
   * @name fetch
   * @param {string} venueId = The VenueID of the desired Spaces to fetch
   * @param {string} version - Defaults to standard
   * @desc Fetches the Spaces for the given Venue
   * @returns {Promise<Space[]>}
   */
  fetch: async function (venueId, version = "standard") {
    if (!venueId) throw new Error(`${venueId} is not defined`);
    if (!this.versions[version])
      throw new Error(`${version} is not an accepted tag version`);
    if (this.versions[version].spaces[venueId])
      return this.versions[version].spaces[venueId];
    return new Promise((resolve) => {
      if (!this.versions[version].inflights[venueId])
        this.versions[version].inflights[venueId] = [];
      this.versions[version].inflights[venueId].push(resolve);
      if (this.versions[version].inflights[venueId].length === 1)
        this.load(venueId, version);
    });
  },
  /**
   * @name load
   * @param {string} venueId = The VenueID of the desired Spaces to fetch
   * @param {string} version  - Defaults to standard
   * @desc Used by the class to perform the actual api call for the Spaces and then resolves all the inflights with instances of the Spaces
   * @returns {Promise<Space[]>}
   */
  load: function (venueId, version = "standard") {
    if (isSSR() || window.isTest) {
      this.versions[version].spaces[venueId] = [];
      if (!isSSR() && window.isTest) {
        while (this.versions[version].inflights[venueId].length) {
          const resolve = this.versions[version].inflights[venueId].shift();
          resolve(this.versions[version].spaces[venueId]);
        }
      }
    } else {
      // getToApi(this.versions[version].url.replace(/:venueId/, venueId), { returnData: true })
      this.versions[version]
        .controller({ venueId })
        .then(({ data: spaces = [] }) => {
          this.versions[version].spaces[venueId] = spaces.map(
            (v) => new Space(v)
          );
          while (this.versions[version].inflights[venueId].length) {
            const resolve = this.versions[version].inflights[venueId].shift();
            resolve(this.versions[version].spaces[venueId]);
          }
        });
    }
  },
  /**
   * @name sdp
   * @param {string} spaceId = The SpaceID of the desired Spaces to fetch
   * @param {string} version - Defaults to sdp
   * @desc Fetches the desired Space from PSQL in the SDP format
   * @returns {Promise<Space>}
   */
  sdp: async function (spaceId, version = "sdp") {
    if (!spaceId) throw new Error(`${spaceId} is not defined`);
    if (!this.versions[version])
      throw new Error(`${version} is not an accepted tag version`);
    if (this.versions[version].spaces[spaceId])
      return this.versions[version].spaces[spaceId];
    return new Promise((resolve) => {
      if (!this.versions[version].inflights[spaceId])
        this.versions[version].inflights[spaceId] = [];
      this.versions[version].inflights[spaceId].push(resolve);
      if (this.versions[version].inflights[spaceId].length === 1)
        this.sdpLoad(spaceId, version);
    });
  },
  /**
   * @name sdpLoad
   * @param {string} spaceId = The SpaceId of the desired Spaces to fetch
   * @param {string} version  - Defaults to standard
   * @desc Used by the class to perform the actual api call for the Spaces and then resolves all the inflights with instances of the Spaces
   * @returns {Promise<Space>}
   */
  sdpLoad: function (spaceId, version = "sdp") {
    if (isSSR() || window.isTest) {
      this.versions[version].spaces[spaceId] = [];
      if (!isSSR() && window.isTest) {
        while (this.versions[version].inflights[spaceId].length) {
          const resolve = this.versions[version].inflights[spaceId].shift();
          resolve(this.versions[version].spaces[spaceId]);
        }
      }
    } else {
      this.sdpFetch(spaceId);
      // getToApi(this.versions[version].url.replace(/:spaceId/, spaceId), { returnData: true })
      // this.versions[version].controller({ spaceId }).then(({ data: space }) => {
      //   this.versions[version].spaces[spaceId] = new SpaceSdp(space)
      //   while (this.versions[version].inflights[spaceId].length) {
      //     const resolve = this.versions[version].inflights[spaceId].shift()
      //     resolve(this.versions[version].spaces[spaceId])
      //   }
      // })
    }
  },
  spaceSdpIds: [],
  sdpFetch: function (spaceId) {
    // console.log(spaceId)
    this.spaceSdpIds.push(spaceId);
    this.sdpRequest();
  },
  sdpRequest: function (version = "sdp") {
    if (!this.debounceSdpRequest) {
      this.debounceSdpRequest = debounce(() => {
        const spaces = [...this.spaceSdpIds];
        // console.log(spaces)
        this.spaceSdpIds = [];
        this.versions[version]
          .controller({ spaces })
          .then(({ data: spaces }) => {
            while (spaces.length) {
              const space = spaces.shift();
              const spaceId = space.oid;
              this.versions[version].spaces[spaceId] = new SpaceSdp(space);
              while (this.versions[version].inflights[spaceId].length) {
                const resolve =
                  this.versions[version].inflights[spaceId].shift();
                resolve(this.versions[version].spaces[spaceId]);
              }
            }
          });
      }, 200);
    }
    this.debounceSdpRequest();
  },
};
if (typeof window !== "undefined") window.Spaces = Spaces;
export default Spaces;
